import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    if (this.data.get("active") === "true") {
      this.timer = window.setTimeout(() => this.poll(), this.interval)
    }
  }

  disconnect() {
    if (this.timer) window.clearTimeout(this.timer)
  }

  poll() {
    if (window.Turbolinks) {
      window.Turbolinks.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }

  get interval() {
    return Number(this.data.get("interval")) || 5000
  }
}
